import React from "react";
import PropTypes from "prop-types";
import { ColumnDefaultProps, ColumnPropTypes } from "../../../props";

import { v4 as uuidv4 } from "uuid";
import classNames from "classnames";

import Content from "./content";
// import Prefix from "./prefix";
// import Suffix from "./suffix";

function Td({ column, text, i, item }) {
  let tdClasses = classNames(
    {
      [`text-${column.text}`]: column.text
    },
    column.className || ""
  );

  return (
    <td
      key={column.id || uuidv4()}
      className={tdClasses}
      colSpan={column.colSpan || null}
      rowSpan={column.rowSpan || null}
    >
      {/*
      // DISABLE FOR NORMAL VIEW
      {column.title && column.title.length ? (
        <span className="table-content-title">
          <Prefix content={column.prefix} />
          {column.title || ""}
          <Suffix content={column.suffix} />
        </span>
      ) : null}
      */}

      <span
        className={`table-content-data ${
          !column.title || !column.title.length ? "padding-no-left" : ""
        }`}
      >
        <span className="table-content-data-wrapper">
          {item ? (
            <Content column={column} text={text} item={item} i={i} />
          ) : // column.title || ""
          null}
        </span>
      </span>
    </td>
  );
}

Td.defaultProps = {
  column: ColumnDefaultProps
};

Td.propTypes = {
  text: PropTypes.any,
  i: PropTypes.number.isRequired,
  column: ColumnPropTypes
};

export default Td;
